import { Component, OnInit } from '@angular/core';
import { DataStorageService } from '../../../data-storage.service';
import { AvailableComponents } from '../../../side-bar/enumAvailableComponents';
import { PricingService } from '../../../pricing.service';
import { ApiService } from '../../../api.service';
import {MobilePricing} from '../../../../models/MobilePricing';
import { Mobile } from '../../../../models/Mobile';
import {MobileOptionModel} from '../../../../models/MobileOption.model';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss']
})
export class MobileComponent implements OnInit {

  public pricingLists: Array<MobilePricing>;
  public mobiles:Array<Mobile>;
  public subscriptions:Array<String>;
  public type: String;
  public extraDataCardsPricing: Array<MobileOptionModel>;
  public extraDataCards: Array<String>;
  public extraWatchCardsPricing: Array<MobileOptionModel>;
  public extraWatchCards: Array<String>;

  private List: MobilePricing;

  constructor(
    public dataStorageService: DataStorageService,
    private api: ApiService,
    private pricing: PricingService) {
    this.mobiles = [];

    pricing.getMobilePriceList().then(data => {
      this.pricingLists = data;
      this.type = this.getTypes();
      this.subscriptions = this.pricingLists.map(price => price.subscription);
    });
    pricing.getMobileOption('MOBILE_Extra_Card_Data').then(data => {
      this.extraDataCardsPricing = data;
      this.extraDataCards = this.extraDataCardsPricing.map(price => price.option);
    });
    pricing.getMobileOption('MOBILE_Extra_Card_Watch').then(data => {
      this.extraWatchCardsPricing = data;
      this.extraWatchCards = this.extraWatchCardsPricing.map(price => price.option);
    });
  }

  ngOnInit() {
    const element = document.getElementById('mobileSide');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['mobile'];
  }

  ngOnDestroy() {
    const element = document.getElementById('mobileSide');
    element.classList.remove('active');
  }

  addMobileClick() {
    var toAddMobile = Mobile.fromPriceList(this.pricingLists[0]);
    this.api.postMobile(this.dataStorageService.currentState.offerID, toAddMobile).then(mobile => {
      this.dataStorageService.currentState.mobiles.push(mobile);
    })
  }

  removeMobileClick(index) {
    var mobile = this.dataStorageService.currentState.mobiles[index];
    this.api.deleteMobile(this.dataStorageService.currentState.offerID, mobile.id).then( res => {
      this.dataStorageService.currentState.mobiles.splice(index, 1)
    })
  }

  setValue(i: number, event: any, type:string) {
    let currentMobile = this.dataStorageService.currentState.mobiles[i];

    if(type == 'subscription') {
      currentMobile.subscription = event.target.value;
    } else if(type == 'extraDataCard'){
      currentMobile.extraCardData = event.target.value;
    } else if(type == 'extraWatchCard'){
      currentMobile.extraCardWatch = event.target.value;
    } else if(type == 'quantity'){
      currentMobile.quantity = event.target.value ? event.target.value : 1;
    }


    this.updatePrices();
  }

  getTypes() {
    return Array.from(new Set(this.pricingLists.map(x => x.type)))[0];
  }


  getCostMonthly() {
    return Array.from(new Set(this.pricingLists.map(x => x.subscriptionMonthly)))[0];
  }

  getCostUnique() {
    return Array.from(new Set(this.pricingLists.map(x => x.subscriptionMonthly)))[0];
  }

  getTotalCosts() {
    return (this.dataStorageService.currentState.mobiles[0].subscriptionMonthly + this.dataStorageService.currentState.mobiles[0].subscriptionUnique +
           this.dataStorageService.currentState.mobiles[0].extraCardDataMonthly + this.dataStorageService.currentState.mobiles[0].extraCardDataUnique +
           this.dataStorageService.currentState.mobiles[0].extraCardWatchMonthly + this.dataStorageService.currentState.mobiles[0].extraCardWatchUnique) * this.dataStorageService.currentState.mobiles[0].quantity;
  }

  updatePrices() {

    const mobiles = this.dataStorageService.currentState.mobiles;
    mobiles.forEach(mobile => {
      //Updating Subscription
      var PriceListForSubscription = this.pricingLists.filter(function(v,i) {
        return v.subscription == mobile.subscription;
      });
      mobile.subscriptionMonthly = PriceListForSubscription[0].costMonthly;
      mobile.subscriptionUnique = PriceListForSubscription[0].costUnique;

      //Updating ExtraCard Data
      var PriceListForExtraCardData = this.extraDataCardsPricing.filter(function(v,i) {
        return v.option == mobile.extraCardData;
      });
      mobile.extraCardDataMonthly = PriceListForExtraCardData[0].monthlyCost;
      mobile.extraCardDataUnique = PriceListForExtraCardData[0].uniqueCost;

      //Updating ExtraCard Watch
      var PriceListForExtraCardWatch = this.extraWatchCardsPricing.filter(function(v,i) {
        return v.option == mobile.extraCardWatch;
      });
      mobile.extraCardWatchUnique = PriceListForExtraCardWatch[0].uniqueCost;
      mobile.extraCardWatchMonthly = PriceListForExtraCardWatch[0].monthlyCost;

      this.api.postMobile(this.dataStorageService.currentState.offerID, mobile).then(mobile => {
      })
    });


  }

  monthlyCosts( mobile : Mobile){
    return (mobile.extraCardWatchMonthly + mobile.extraCardDataMonthly + mobile.subscriptionMonthly) * mobile.quantity;
  }

  uniqueCosts( mobile : Mobile){
    return (mobile.extraCardWatchUnique + mobile.extraCardDataUnique + mobile.subscriptionUnique) * mobile.quantity;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplefone-mobile/mobile.component.ts